import { render, staticRenderFns } from "./StartPoint.vue?vue&type=template&id=33a47a76&"
import script from "./StartPoint.vue?vue&type=script&lang=js&"
export * from "./StartPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports